<template> 
    <div class="product-details-container"> 
        <Summary :product='product'/>
        <ProductButtons v-if='in_stock && product.availability_color != "red"' :product='product' :variant_code='variant_code' :in_stock='in_stock' @updatedCartListener='updatedCartListener'/>
        <!-- <div v-if='!in_stock' class="out-of-stock-message">Sorry, this product is currently out of stock.</div> -->
    </div>
</template>
<script>
import Summary from '@/ecom/components/products/single_product/details/Summary.vue';
import ProductButtons from '@/ecom/components/products/single_product/details/ProductButtons.vue';

export default {
    components: {Summary, ProductButtons},
    emits: ['updatedCartListener'],
    props: ['product', 'variant_code', 'in_stock'],
    methods:{
        updatedCartListener(){
            this.$emit('updatedCartListener');
        }
    }
}
</script>
<style lang="scss" scoped>
.product-details-container{
    display: flex;
    gap: 70px;
    @media(max-width: 1200px){
        flex-direction: column;
        gap: 24px;
    }
    // flex-wrap: wrap;
    // @media(max-width:1292px) {
    //     gap:30px;
    //     justify-content: center;
    // } 
}
.out-of-stock-message{
    height         : 50px;
    width          : 169px;
    background     :  #eeedac;
    border-radius  :  3px;	
    border-color   :  #eeedac;
    border         :  1px solid #ffffff;
    padding        :  5px 7px;
    font-size      :  0.90rem;
}
</style>